import React, { useState, useEffect } from 'react';
import { useDispatch } from 'react-redux';
import Modal from 'react-modal';
import { Input, message } from 'antd';
import moment from 'moment';
import './index.css';
import {
  load,
  getLoadNotes,
  getStopNotes,
  getOrderNotes,
  setLoadNote,
  setStopNote,
  setOrderNote,
  setEmptyAllNotes,
  resetError,
  getLoadDetails,
} from '../../../../../store/actions/callCheckLoadsActions/callCheckLoads';
import Loading from '../../../screen/loading';
import { CallCheckLoadsSelectors } from '../../../../../store/selectors/callCheckLoadsSelectors';

const { TextArea } = Input;

const NotesModal = ({ setOrderNotesModalIsOpen, orderNotesModalIsOpen, rowState, resource, page, loadType, isLoad }) => {
  const dispatch = useDispatch();
  const { loadDetails, notesLoading, actionMessage, hasError, loadNotes, stopNotes, orderNotes, stateFilterOptions, statePagination } = CallCheckLoadsSelectors();
  const type = rowState.type === 'stop' ? 'stop' : rowState.type === 'load' ? 'load' : rowState.type === 'order' ? 'order' : '';

  const closeModal = () => {
    setOrderNotesModalIsOpen(false);
    dispatch(getLoadDetails(resource, loadDetails.loadId))
    dispatch(load(resource, page, stateFilterOptions, statePagination, 'withoutLoading'));
  };

  useEffect(() => {
    if (type === 'load' || isLoad) {
      dispatch(getLoadNotes(resource, rowState, loadType));
    } else if (type === 'stop') {
      dispatch(getStopNotes(resource, rowState));
    } else if (type === 'order') {
      dispatch(getOrderNotes(resource, rowState));
    }
  }, [dispatch, isLoad, loadType, resource, rowState, type]);

  useEffect(() => {
    if (hasError) {
      message.error(actionMessage);
      resetError(resource);
    }
  }, [hasError, actionMessage, resource]);

  useEffect(() => {
    return () => {
      dispatch(setEmptyAllNotes(resource));
    };
  }, [dispatch, resource]);

  const [newNote, setNewNote] = useState('');

  const customStyles = {
    content: {
      top: '50%',
      left: '50%',
      right: 'auto',
      bottom: 'auto',
      marginRight: '-50%',
      transform: 'translate(-50%, -50%)',
      minWidth: '600px',
      minHeight: '300px',
      maxWidth: '600px',
      maxHeight: '400px',
      borderRadius: '8px',
      padding: notesLoading ? '100px 0' : '6px 0',
    },
  };

  const saveNote = () => {
    if (type === 'load' || isLoad) {
      dispatch(setLoadNote(resource, rowState, newNote, loadType));
    } else if (type === 'stop') {
      dispatch(setStopNote(resource, rowState, newNote));
    } else if (type === 'order') {
      dispatch(setOrderNote(resource, rowState, newNote));
    }
    setNewNote('');
  };

  const getLoadStatusNameById = id => {
    const statusesList = {
      0: '-',
      1: 'Ready to be Picked Up',
      2: 'In Transit',
      3: 'Delivered',
      4: 'Delayed',
    };
    return statusesList?.[id];
  };

  const getStopStatusNameById = id => {
    const statusesList = {
      0: '-',
      1: 'Ready for Pick Up',
      2: 'On the Way',
      3: 'Near Location',
      4: 'On-Site',
      5: 'In-Door Process',
      6: 'In Transit',
      7: 'Delivered',
      8: 'Delayed',
      9: 'Issue',
    };
    return statusesList?.[id];
  };

  return (
    <Modal isOpen={orderNotesModalIsOpen} onRequestClose={closeModal} style={customStyles} ariaHideApp={false}>
      <div className='comment_modal__container'>
        {notesLoading ? (
          <Loading />
        ) : (
          <>
            <div className='comment_modal__x-btn' onClick={closeModal}>
              X
            </div>
            <>
              <div className='comment_modal_text'>Notes</div>
              <table className='comment-modal__table'>
                <thead>
                  <tr className='comment-modal__tr'>
                    <th className='comment-modal__th'>Status</th>
                    <th className='comment-modal__th'>Comments</th>
                    <th className='comment-modal__th'>Date and Time</th>
                    <th className='comment-modal__th'>Created By</th>
                  </tr>
                </thead>
                {loadNotes?.data?.length
                  ? loadNotes?.data?.map(note => (
                      <tr className='comment-modal__tr' key={note?.id}>
                        <td className='comment-modal__td'>{getLoadStatusNameById(note?.stopStatus)}</td>
                        <td className='comment-modal__td'>{note?.comment}</td>
                        <td className='comment-modal__td'>{moment(note?.createDate).format('MM/DD/YY HH:mm')}</td>
                        <td className='comment-modal__td'>{note?.user}</td>
                      </tr>
                    ))
                  : null}
                {stopNotes?.data?.length
                  ? stopNotes?.data?.map(note => (
                      <tr className='comment-modal__tr' key={note?.id}>
                        <td className='comment-modal__td'>{getStopStatusNameById(note?.stopStatus)}</td>
                        <td className='comment-modal__td'>{note?.notes}</td>
                        <td className='comment-modal__td'>{moment(note?.createDate).format('MM/DD/YY HH:mm')}</td>
                        <td className='comment-modal__td'>{note?.user}</td>
                      </tr>
                    ))
                  : null}
                  {orderNotes?.data?.length
                  ? orderNotes?.data?.map(note => (
                      <tr className='comment-modal__tr' key={note?.id}>
                        <td className='comment-modal__td'>{getStopStatusNameById(note?.stopStatus)}</td>
                        <td className='comment-modal__td'>{note?.comment}</td>
                        <td className='comment-modal__td'>{moment(note?.createDate).format('MM/DD/YY HH:mm')}</td>
                        <td className='comment-modal__td'>{note?.user}</td>
                      </tr>
                    ))
                  : null}
              </table>
              <div className='add-comment__container'>
                <div className='add_new_comment'>Add new note</div>
                <TextArea
                  placeholder='Add new note'
                  autoSize={{ minRows: 2, maxRows: 6 }}
                  className='reject-reason__input'
                  status={'error'}
                  onChange={e => setNewNote(e.target.value)}
                  value={newNote}
                />
              </div>
              <div className='commnet__add-btn__container'>
                <button disabled={!newNote} className={`${!newNote && 'disabled__add-btn'} comment-modal-button`} type='submit' onClick={saveNote}>
                  Add
                </button>
              </div>
            </>
          </>
        )}
      </div>
    </Modal>
  );
};

export default NotesModal;
